import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as MailIcon } from 'assets/icons/mail.svg';
import Button from 'components/common/Button/Button';
import useAuthentication from 'hooks/api/useAuthentication';
import useUser from 'redux/authentication/hooks/useUser';
import requestAPI from 'utils/apiHandler';

import styles from './ConfirmCodeModal.module.scss';

const RequestVerificationCode: React.FC = () => {
  const [isResending, setIsResending] = useState(false);
  const { t } = useTranslation();
  const user = useUser();
  const { getCurrentUser, logOut } = useAuthentication();

  const resendCode = async () => {
    setIsResending(true);
    await requestAPI({
      url: '/user/resend-verification',
      method: 'PUT',
    });
    await getCurrentUser();
    setIsResending(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerTop}>
        <div className={styles.emailMessage}>
          <div className={styles.iconContainer}>
            <MailIcon />
          </div>
          <br />
          {t('login:noVerificationCodeSent')}
          <br />
          {t('login:requestNewCodeToActivate', { email: user?.email })}
        </div>
      </div>
      <br />
      <div className={styles.resendContainer}>
        <Button
          variant="primary"
          size="large"
          label={t('login:resendCode')}
          onClick={resendCode}
          isLoading={isResending}
          disabled={isResending}
        />
      </div>
      {user?.email && (
        <div className={styles.header}>
          <div className={styles.link} onClick={logOut}>
            {t('common:logout')}
          </div>
        </div>
      )}
    </div>
  );
};

export default RequestVerificationCode;
